import React, {useState} from 'react';
import Valg from '../../Shared/Scripts/Models/Valg';

interface SliderOwnProps {
    id: string,
    collapsed: boolean,
    valg: Valg<string> | undefined,
    label: JSX.Element | null,
    locale: string,
    value: string | undefined,
    maxInput: number,
    minSlider: number,
    minAllowInput: string,
    posibleToSetZero: boolean,
    formatNumber: boolean,
    maxSlider: number,
    sliderStep: number,
    valuta?: string | null,
    onChangeHandler: any,
    useDecimal: boolean
}

export function SliderComponent (props: SliderOwnProps): JSX.Element {
    const [belop, setBelop] = useState(props.value);

    function dispatch(value: string): void {
        let valg: Valg<string> = { id: '', displayValue: value, value: value }
        props.onChangeHandler(valg);
    }

    function inputHandler(e: React.SyntheticEvent<HTMLInputElement>): void {

        if(props.useDecimal) {

            //kun tall, komma og punktum som er lov.
            let tmpParsed: string = e.currentTarget.value.replace(/[^0-9.,]/g, ''); 
            //bytter ut alle komma med punktum. 
            let stringVal: string = tmpParsed.replace(/,/g, '.'); 

            if(stringVal === "") {
                setBelop("");
                dispatch("");
                return;
            }

            //sjekker om siste bokstav er en punktum og sjekker om det er eneste punktumen i stringen.
            if(stringVal.slice(-1) === "." && stringVal.split(".").length - 1 === 1) {
                setBelop(stringVal);
                dispatch(stringVal);
                return;
            }

            //omgjør stringen til en float med maks 3 desimaler.
            let val: number = parseFloat( parseFloat(stringVal).toFixed(3));
            if(val <= props.maxInput) {
                setBelop(val.toString());
                dispatch(val.toString());
            }
        } else {
            let stringVal: string = e.currentTarget.value.replace(/[^0-9]/g,''); 
            let val: number = 0;
    
            if(stringVal === "") {
                setBelop("");
                dispatch("");
                return;
            }
    
            val = parseInt(stringVal.replace(/\s/g,''));
    
            if(val <= props.maxInput) {
                if(val === 0 && !props.posibleToSetZero) {
                    setBelop(props.minAllowInput);
                    dispatch(props.minAllowInput);
                } else {
                    setBelop(stringVal.replace(/\s/g,''));
                    dispatch(stringVal.replace(/\s/g,''));
                }
            }
        }
    }

    function formatNumber(tall: any): string {
        if(!props.formatNumber)
            return tall;

        let tallSomString: string = tall.toString();

        if(props.locale === 'en-US') {
            tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',');
        } else {
            tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
        }
        return tallSomString;
    }

    
    function rangeHandler(e: React.SyntheticEvent<HTMLInputElement>) {
        if(e.currentTarget.value === "0" && !props.posibleToSetZero) {
            setBelop(props.minAllowInput);
            dispatch(props.minAllowInput);
        } else {
            setBelop(e.currentTarget.value);
            dispatch(e.currentTarget.value);
        }
    }

    return (

        <div className={"c-veileder--mini-twocolumn-container"}>
            <label id={"c-veileder-betkalk-" + props.id} className="c-veileder__undersporsmal c-veileder--mini-twocolumn-first-item c-veileder--mini-twocolumn-item">
                {props.label}
            </label>
            <div className="c-veileder--mini-twocolumn-second-item c-veileder--mini-twocolumn-item">
                <div className="c-number-input c-number-input--big ">
                    <input id={`c-veileder-betkalk-${props.id}-input`} disabled={props.collapsed} onInput={inputHandler} aria-labelledby={"c-veileder-betkalk-" + props.id} value={formatNumber(belop)} onChange={() => {}}  className={"c-number-input__input "} type="text" />
                    <div className="c-range-input--postfix">
                        {props.valuta}
                    </div>
                </div>
                <div className="c-range-input">
                    <input disabled={props.collapsed} aria-labelledby={"c-veileder-betkalk-" + props.id} min={props.minSlider} max={props.maxSlider} step={props.sliderStep} onChange={rangeHandler} value={belop} type="range" className="c-range-input__input" />
                    <div className="c-range-input--postfix">
                        &nbsp;&nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    );
};
